import { ReckonAlarmState } from '@rocksoft/inroom-sdk';

import { Action } from '@ngrx/store';

export enum AlarmActionTypes {
  ALARM_API_ALARM_LOADED = '[Alarm API] Alarm Loaded',
  ALARM_API_NO_ALARM = '[Alarm API] No Alarm',

  ALARM_SIGNALR_STATE_CHANGE = '[Alarm SignalR] Alarm State Changed',
  ALARM_EFFECT_ALARM_RESETTED = '[Alarm Effect] Alarm Resetted',
}

export class AlarmLocationModel {
  hotelCode: string;
  room: string;
  state?: ReckonAlarmState;
  time?: string;
  typeCode?: string;
}

export class AlarmApiAlarmLoaded implements Action {
  readonly type = AlarmActionTypes.ALARM_API_ALARM_LOADED;

  constructor(public payload: AlarmLocationModel) {}
}

export class AlarmApiNoAlarm implements Action {
  readonly type = AlarmActionTypes.ALARM_API_NO_ALARM;
}

export class AlarmSignalRStateChange implements Action {
  readonly type = AlarmActionTypes.ALARM_SIGNALR_STATE_CHANGE;

  constructor(public payload: { id: string; changes: AlarmLocationModel }) {}
}

export class AlarmEffectAlarmResetted implements Action {
  readonly type = AlarmActionTypes.ALARM_EFFECT_ALARM_RESETTED;

  constructor(public payload: { id: string; changes: AlarmLocationModel }) {}
}

export type AlarmActionsUnion =
  | AlarmApiAlarmLoaded
  | AlarmApiNoAlarm
  | AlarmSignalRStateChange
  | AlarmEffectAlarmResetted;
